<template>
    <slot
        v-bind="{
            variants,
            selectedVariant,
            addToCart,
            addToCartLoading,
            variant,
            isInCart,
            variantsOptions,
            giftWrap,
            giftWrapText,
            options,
            optionValues,
            quantity,
            updateQuantity,
            maxQuantity,
        }"
    ></slot>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const {
    productId, variants, options, initialVariant,
} = defineProps({
    productId: {
        type: Number,
        required: true,
    },
    variants: {
        type: Array,
        required: true,
    },
    options: {
        type: Array,
        default: () => { return ([]); },
    },
    initialVariant: {
        type: Number,
        required: true,
    },
});

const selectedVariant = ref(initialVariant);

const variant = computed(() => {
    return variants.find((variant) => { return parseInt(variant.id) === selectedVariant.value; });
});

const variantsOptions = computed(() => {
    return variants.map((variant) => {
        return {
            value: variant.id,
            label: variant.title,
        };
    });
});

const optionValues = computed(() => {
    const optionValues = {};

    for (const option of options) {
        if (option.type === 'checkboxes') {
            optionValues[option.label] = [];
        } else {
            optionValues[option.label] = null;
        }
    }

    return optionValues;
});

const store = useStore();
const isInCart = computed(() => {
    return store.getters['cart/isInCart'](selectedVariant.value);
});

const quantity = ref(1);

const maxQuantity = computed(() => {
    if (variant.value.hasUnlimitedStock) {
        return Infinity;
    }

    return variant.value.maxQty ? variant.value.maxQty : variant.value.stock;
});

function updateQuantity(value) {
    quantity.value = value;
}

const giftWrap = ref(false);
const giftWrapText = ref('');
const giftWrapOptions = computed(() => {
    const options = {};

    if (giftWrap.value) {
        options['Gift Wrap'] = 'Yes';
        options.Message = giftWrapText.value;
    }

    return options;
});

const addToCartLoading = ref(false);

async function addToCart() {
    if (isInCart.value) {
        location.href = '/shop/checkout';
        return;
    }

    addToCartLoading.value = true;

    const options = {
        ...optionValues.value,
        ...giftWrapOptions.value,
    };

    await store.dispatch('cart/addToCart', {
        id: selectedVariant.value,
        quantity: quantity.value,
        options,
    });

    addToCartLoading.value = false;
}
</script>
